import { ReactNode } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

export type SectionTabOption = {
  value: string;
  label: string;
  icon?: ReactNode;
  disabled?: boolean;
};

type SectionTabsProps = {
  value: string;
  options: SectionTabOption[];
  onChange: (value: string) => void;
  ariaLabel: string;
};

export const SectionTabs = ({ value, options, onChange, ariaLabel }: SectionTabsProps) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    size="small"
    aria-label={ariaLabel}
    onChange={(_, nextValue: string | null) => {
      if (nextValue !== null) onChange(nextValue);
    }}
    sx={{
      p: 0.5,
      width: "100%",
      maxWidth: "100%",
      overflowX: "auto",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1.5,
      bgcolor: "background.paper",
      "& .MuiToggleButtonGroup-grouped": { border: 0, borderRadius: "8px !important", mx: 0 },
      "& .MuiToggleButton-root": {
        flex: "0 0 auto",
        px: { xs: 1.25, sm: 1.75 },
        minHeight: 38,
        textTransform: "none",
        gap: 0.75,
        whiteSpace: "nowrap",
      },
    }}
  >
    {options.map(({ value: optionValue, label, icon, disabled }) => (
      <ToggleButton key={optionValue} value={optionValue} disabled={disabled}>
        {icon}
        {label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
